import { i18nMark } from 'lingui-react';

const messages = {
  title: i18nMark('Options'),
  printPage: i18nMark('Print Page'),
  viewInFullScreenMode: i18nMark('View In Full-Screen Mode'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/OptionsButton/messages.js